<template>
  <div class="pe-form f-s-14 p-15">
    <div class="c-333 m-b-15">
      <div class="d-f">
        <span class="w-180">质控价格：当前项目去重后</span>
        <span class="c-primary w-230">
          稿件总字数：{{ childConfigInfo.wordsCount }}（字）
        </span>
        <span class="c-primary">
          稿件总句子数：{{ childConfigInfo.rowCount }}句
        </span>
      </div>
      <section v-if="childConfigInfo.isMtOut" class="p-l-180">
        <div class="d-f c-primary">
          <span class="w-230">
            机翻直出字数：{{ mtInfo.mtoutWordNum }}（字）
          </span>
          <span class="m-r-60">
            机翻直出句子数：{{ mtInfo.mtoutSentNum }}句
          </span>
        </div>
        <div class="d-f c-primary">
          <span class="w-230">
            例句填充字数：{{ mtInfo.exampleWordNum }}（字）
          </span>
          <span>例句填充句子数：{{ mtInfo.exampleSentNum }}句</span>
        </div>
        <div class="d-f c-primary">
          <span>稿件重复率：{{ mtInfo.repeatRate }}%</span>
        </div>
      </section>
    </div>
    <div
      class="d-f align-c m-b-10"
      v-if="childConfigInfo.status == ORDER_STATUS.toBeConfig"
    >
      <span class="c-333 w-110">
        <span class="c-red">*</span>
        任务截止时间：
      </span>
      <el-date-picker
        v-model="childConfigInfo.limitTime"
        type="datetime"
        @input="handleTime"
        valueFormat="timestamp"
        format="yyyy-MM-dd HH:mm"
        :pickerOptions="this.pickerOptions"
        placeholder="选择任务截止时间"
      ></el-date-picker>
      <span class="c-999 f-s-12" v-if="childConfigInfo?.peEndTime">
        （截止时间不能小于PE结束时间：{{
          childConfigInfo?.peEndTime
            ? formatDate(childConfigInfo?.peEndTime)
            : ''
        }}）
      </span>
    </div>
    <section
      v-if="
        childConfigInfo.canDistribute == 1 &&
        childConfigInfo.status == ORDER_STATUS.toBeConfig
      "
    >
      <div class="d-f align-c m-tb-15">
        <h4 class="w-110">第一步</h4>
        <div v-if="showFirstStepBtn && !childConfigInfo.distributedStatus">
          <el-button type="primary" @click="sysDispatch">
            系统按照产能尝试派单
          </el-button>
          <el-button type="primary" plain @click="skipFirstStep">
            跳过第一步
          </el-button>
        </div>
        <div v-if="!showFirstStepBtn && skipStepFlag" class="c-red f-w-600">
          已跳过派单流程，请手动拆分质控任务！
        </div>
        <div v-if="childConfigInfo.distributedStatus == 1">
          派单中，请刷新页面查看派单结果
        </div>
        <div v-if="childConfigInfo.distributedStatus == 2">系统派单完成</div>
        <div
          v-if="childConfigInfo.distributedStatus == 3"
          class="c-red f-w-600"
        >
          系统暂无可派单的人员，请手动拆分质控
        </div>
      </div>
      <div class="d-f align-c">
        <h4 class="w-110">第二步</h4>
        <el-button
          v-if="
            showSecondStepBtn &&
            childConfigInfo.status == ORDER_STATUS.toBeConfig
          "
          type="info"
          plain
          disabled
        >
          人工手动拆分质控
        </el-button>
      </div>
    </section>
    <section
      v-if="
        childConfigInfo.status > ORDER_STATUS.toBeConfig ||
        childConfigInfo.distributedStatus == 3 ||
        (!showFirstStepBtn && skipStepFlag) ||
        childConfigInfo.canDistribute == 0
      "
    >
      <div v-if="taskListOption.length" class="m-t-15">
        <div class="c-333 w-110 m-b-5">质控任务明细：</div>
        <div
          class="c-primary f-s-12 m-b-5"
          v-if="childConfigInfo.status > ORDER_STATUS.toBeConfig"
        >
          当前质控费用合计：{{ totalAmount }}元
        </div>
        <el-table
          :data="taskListOption"
          :row-class-name="tableRowClassName"
          border
          style="width: 100%; overflow: auto"
        >
          <el-table-column prop="qcTaskId" label="质控单号">
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column prop="taskType" label="质控类型" width="70">
            <template slot-scope="scope">
              {{ scope.row.taskType == 1 ? '主质控' : '子质控' }}
            </template>
          </el-table-column>
          <el-table-column prop="price">
            <template v-slot:header>
              <div>
                <span class="c-red">*</span>
                质控单价（千字单价）
                <el-input-number
                  v-if="childConfigInfo.status === ORDER_STATUS.toBeConfig"
                  class="w-65"
                  :controls="false"
                  v-model="batchPrice"
                  :precision="2"
                  :min="0"
                  placeholder="请输入"
                  @blur="blurBatchPrice"
                />
              </div>
            </template>
            <template slot-scope="scope">
              <div
                v-if="
                  childConfigInfo.status > ORDER_STATUS.toBeConfig &&
                  !scope.row.isEdit
                "
                :class="[
                  scope.row.wordNum == 0 || scope.row.wordNum == null
                    ? 'c-red'
                    : '',
                ]"
              >
                {{ scope.row.price || 0 }}
              </div>
              <div v-if="scope.row.isEdit" class="d-f align-c">
                <el-tooltip placement="top-start" effect="dark">
                  <div slot="content">
                    建议价格：{{ recommendPrice }}元/千字
                  </div>
                  <el-input-number
                    :class="[
                      scope.row.price == null
                        ? 'w-65 m-r-5 border-red'
                        : 'w-65 m-r-5',
                    ]"
                    :controls="false"
                    @blur="blurPrice(scope.row.index, scope.row.price)"
                    v-model="scope.row.price"
                    :precision="2"
                    :min="0"
                    placeholder="请输入质控价格"
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="wordNum" width="130">
            <template v-slot:header>
              <div>
                <el-tooltip
                  content="系统将会根据输入的字数进行整句切分后重新返回最新字数"
                  placement="top-start"
                  effect="dark"
                >
                  <span>
                    <span class="c-red">*</span>
                    预估任务字数
                    <i class="el-icon-question c-red"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div v-if="scope.row.isEdit">
                <el-input-number
                  :class="[
                    scope.row.wordNum == null
                      ? 'w-85 m-r-5 border-red'
                      : 'w-85 m-r-5',
                  ]"
                  :controls="false"
                  @blur="checkWordNum(scope.row.index, scope.row.wordNum)"
                  v-model="scope.row.wordNum"
                  :precision="0"
                  :min="0"
                  placeholder="请输入字数"
                />
                字
              </div>
              <div v-else>
                <span
                  :class="[
                    scope.row.wordNum == 0 || scope.row.wordNum == null
                      ? 'c-red'
                      : '',
                  ]"
                >
                  {{ scope.row.wordNum || 0 }}
                </span>
                字
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sentNum" label="任务句数" width="70">
            <template slot-scope="scope">
              <div>({{ scope.row.sentNum || 0 }}句)</div>
            </template>
          </el-table-column>
          <el-table-column prop="extraAmount" width="90">
            <template v-slot:header>
              <div>
                <el-tooltip
                  content="请输入其他要付给质控的费用，例如凑整、抹零等；可输入负数"
                  placement="top-start"
                  effect="dark"
                >
                  <span>
                    额外费用
                    <i class="el-icon-question c-red"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                v-if="
                  childConfigInfo.status > ORDER_STATUS.toBeConfig &&
                  !scope.row.isEdit
                "
              >
                {{ scope.row.extraAmount }}
              </div>
              <div v-if="scope.row.isEdit" class="d-f align-c">
                <el-input-number
                  :controls="false"
                  @blur="getTotalAmount(scope.row.index)"
                  v-model="scope.row.extraAmount"
                  :precision="2"
                  placeholder="请输金额"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="totalPrice" label="质控总费用" width="85">
            <template slot-scope="scope">
              <div>
                {{ scope.row.amount }}元
                <el-popover width="400" trigger="hover">
                  <div class="f-s-12 c-999">
                    <div v-if="configInfo.isMtOut">
                      机翻直出：
                      <span
                        v-if="
                          scope.row.mtoutWordNum == 0 &&
                          scope.row.modifiedMtoutWordNum == 0
                        "
                      >
                        0元
                      </span>
                      <span v-else>
                        {{ scope.row.mtoutWordNum }}字*{{
                          scope.row.price
                        }}元/千字*{{
                          (scope.row.mtoutDisCount
                            ? scope.row.mtoutDisCount
                            : mtoutDisCount) * 100
                        }}%
                        <span
                          v-if="
                            scope.row.modifiedMtoutWordNum &&
                            Number(scope.row.modifiedMtoutWordNum) > 0
                          "
                        >
                          +{{ scope.row.modifiedMtoutWordNum }}字*{{
                            scope.row.pePrice
                          }}元/千字*{{ scope.row.modifiedMtoutDisCount * 100 }}%
                        </span>
                        ={{ scope.row.mtoutAmount }}元
                      </span>
                    </div>
                    <div class="flex">
                      <span>例句直出：</span>
                      <div>
                        <div
                          v-for="(item, index) in scope.row.exampleTaskInfoList"
                          :key="index"
                        >
                          {{ item.descripetion }}&nbsp;&nbsp;{{ item.value }}
                        </div>
                      </div>
                    </div>
                    <div>
                      质控费用：
                      <span v-if="!scope.row.wordNum || !scope.row.price">
                        0
                      </span>
                      <span v-else>
                        {{ scope.row.normalWordNum }}字*{{
                          scope.row.price
                        }}元/千字={{ scope.row.normalAmount }}
                      </span>
                      元
                    </div>
                    <div>额外费用：{{ scope.row.extraAmount }}元</div>
                    <div>合计费用：{{ scope.row.amount }}元</div>
                  </div>
                  <i
                    v-show="
                      childConfigInfo.status > ORDER_STATUS.toBeConfig &&
                      !scope.row.isEdit
                    "
                    slot="reference"
                    class="el-icon-question c-red"
                  ></i>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="qcList" min-width="140">
            <template v-slot:header>
              <div>
                <span class="c-red">*</span>
                质控人
                <el-select
                  v-if="childConfigInfo.status === ORDER_STATUS.toBeConfig"
                  class="w-100"
                  placeholder="推送范围"
                  v-model="batchAutoRange"
                  @change="setBatchRange"
                >
                  <el-option label="仅领域圈子推送" :value="1"></el-option>
                  <el-option label="系统全员推送" :value="2"></el-option>
                </el-select>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                v-if="
                  childConfigInfo.status > ORDER_STATUS.toBeConfig &&
                  !scope.row.isEdit
                "
                class="d-f align-c"
              >
                <span class="m-r-10" v-if="scope.row.isMatch == 1">
                  手动邀请
                </span>
                <span class="m-r-10" v-if="scope.row.isMatch == 2">
                  自动匹配
                  <span>
                    {{
                      scope.row.autoRange == 1
                        ? '仅领域圈子推送'
                        : '系统全员推送'
                    }}
                  </span>
                </span>
                <span class="m-r-10" v-if="scope.row.isMatch == 3">
                  系统派单
                </span>
                <span class="m-r-10" v-if="scope.row.isMatch == 4">改派</span>
                <el-tooltip placement="top-start" effect="dark">
                  <div slot="content">{{ scope.row.qcNameList }}</div>
                  <div
                    v-show="
                      scope.row.status <= 1 && scope.row.userWebVos.length
                    "
                    class="qcList qcNameList p-lr-5 m-r-5"
                  >
                    {{ scope.row.qcNameList }}
                  </div>
                </el-tooltip>
                <el-tooltip placement="top-start" effect="dark">
                  <div slot="content">
                    {{ scope.row.receiver }}
                    <span class="c-409EFF" v-if="scope.row.newPerson === 2">
                      (新人)
                    </span>
                  </div>
                  <div
                    v-show="scope.row.status > 1 && scope.row.receiver"
                    class="qcList qcNameList p-lr-5 m-r-5"
                  >
                    {{ scope.row.receiver }}
                    <span class="c-409EFF" v-if="scope.row.newPerson === 2">
                      (新人)
                    </span>
                  </div>
                </el-tooltip>
              </div>
              <div v-if="scope.row.isEdit" class="d-f align-c">
                <el-select
                  class="w-100 m-r-10"
                  @change="changeMatchType($event, scope.row.index)"
                  v-model="scope.row.isMatch"
                  placeholder="请选择"
                >
                  <el-option label="自动匹配" :value="2"></el-option>
                  <el-option
                    v-if="showHandInvite(scope.row)"
                    label="手动邀请"
                    :value="1"
                  ></el-option>
                </el-select>
                <el-select
                  v-if="scope.row.isMatch == 2"
                  class="w-100 m-r-10"
                  v-model="scope.row.autoRange"
                  @change="checkConfigInfo"
                >
                  <el-option label="仅领域圈子推送" :value="1"></el-option>
                  <el-option label="系统全员推送" :value="2"></el-option>
                </el-select>
                <el-button
                  v-if="!scope.row.userWebVos.length && scope.row.isMatch == 1"
                  type="primary"
                  plain
                  @click.stop="showZktr(scope.row.index)"
                >
                  选择质控人
                </el-button>
                <section v-if="scope.row.isMatch != 2">
                  <el-tooltip placement="top-start" effect="dark">
                    <div slot="content">{{ scope.row.qcNameList }}</div>
                    <div
                      v-show="
                        scope.row.status <= 1 && scope.row.userWebVos?.length
                      "
                      class="qcList p-lr-5 m-r-5"
                    >
                      {{ scope.row.qcNameList }}
                    </div>
                  </el-tooltip>
                  <el-tooltip placement="top-start" effect="dark">
                    <div slot="content">
                      {{ scope.row.receiver }}
                      <span class="c-409EFF" v-if="scope.row.newPerson === 2">
                        (新人)
                      </span>
                    </div>
                    <div
                      v-show="scope.row.status > 1 && scope.row.receiver"
                      class="qcList qcNameList p-lr-5 m-r-5"
                    >
                      {{ scope.row.receiver }}
                      <span class="c-409EFF" v-if="scope.row.newPerson === 2">
                        (新人)
                      </span>
                    </div>
                  </el-tooltip>
                  <i
                    v-if="scope.row.userWebVos.length"
                    class="el-icon-close c-p"
                    @click.stop="delAllZkr(scope.row.index)"
                  />
                </section>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row.status == -1">已取消</span>
              <span v-if="scope.row.status == 0">未开始</span>
              <span v-if="scope.row.status == 1">待领取</span>
              <span v-if="scope.row.status == 2">进行中</span>
              <span v-if="scope.row.status == 3">已提交</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="childConfigInfo.status > ORDER_STATUS.toBeConfig"
            prop="limitTime"
            label="要求完成时间"
            min-width="120"
          >
            <template slot-scope="scope">
              <div
                v-if="
                  childConfigInfo.status > ORDER_STATUS.toBeConfig &&
                  !scope.row.isEdit
                "
              >
                {{
                  scope.row?.limitTime ? formatDate(scope.row?.limitTime) : '-'
                }}
              </div>
              <el-date-picker
                v-if="scope.row.isEdit"
                v-model="scope.row.limitTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                valueFormat="timestamp"
                :pickerOptions="pickerOptions"
                placeholder="请选择"
              ></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            v-if="childConfigInfo.status > ORDER_STATUS.toBeConfig"
            prop="sendTime"
            label="派发时间"
            width="120"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.sendTime">
                {{ formatDate(scope.row?.sendTime) }}
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="action" label="操作" width="85">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status == 2"
                type="text"
                size="small"
                @click="openReAssign(scope.row)"
              >
                改派
              </el-button>
              <el-button
                v-if="scope.row.status >= 1"
                type="text"
                size="small"
                @click="openLogList(scope.row.id)"
              >
                日志
              </el-button>
              <el-button
                v-if="configInfo.status == 1"
                type="text"
                size="small"
                @click="resetRow(scope.row.index)"
              >
                清空
              </el-button>
              <el-button
                v-show="
                  !scope.row.isEdit &&
                  (configInfo.status == 2 ||
                    (configInfo.status == 3 &&
                      scope.row.status < 2 &&
                      scope.row.status != -1))
                "
                type="text"
                size="small"
                :disabled="btnActFlag"
                @click="updateRow(scope.row.index)"
              >
                编辑
              </el-button>
              <el-button
                v-show="
                  (configInfo.status == 2 ||
                    (configInfo.status == 3 &&
                      scope.row.status < 2 &&
                      scope.row.status != -1)) &&
                  scope.row.isEdit
                "
                type="text"
                size="small"
                class="m-l-0"
                @click="updateConfig(scope.row.index)"
              >
                确定
              </el-button>
              <el-button
                v-show="
                  (configInfo.status == 2 ||
                    (configInfo.status == 3 &&
                      scope.row.status < 2 &&
                      scope.row.status != -1)) &&
                  scope.row.isEdit
                "
                type="text"
                size="small"
                @click="cancelConfig"
              >
                取消
              </el-button>
              <el-button
                v-if="
                  scope.row.index != 0 &&
                  ((scope.row.status == 0 && configInfo.status == 1) ||
                    (configInfo.status == 2 && !scope.row.isEdit) ||
                    (configInfo.status == 3 &&
                      scope.row.status < 2 &&
                      scope.row.status != -1 &&
                      !scope.row.isEdit))
                "
                :disabled="btnActFlag"
                type="text"
                size="small"
                @click="deleteTask(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="t-c p-t-20"
        v-if="surplusWord > 0 && childConfigInfo.status < ORDER_STATUS.finished"
      >
        <span
          :class="[
            btnActFlag || addBtnActFlag ? 'c-n c-C0C4CC' : 'c-p c-primary',
          ]"
          @click="addQcTask"
        >
          <i class="el-icon-circle-plus-outline"></i>
          新增质控任务
        </span>
      </div>
    </section>
    <div class="m-t-15">
      <div class="c-primary m-b-10">
        剩余待分配字数：
        <span class="c-red">{{ surplusWord }}</span>
        字，剩余待分配字数为0才可开始质控
      </div>
      <el-button
        v-if="childConfigInfo.status == ORDER_STATUS.toBeConfig"
        :disabled="
          configDisabled || childConfigInfo.limitTime == null || surplusWord > 0
        "
        type="primary"
        @click="confirmConfig"
      >
        确定开始质控
      </el-button>
    </div>

    <!-- 改派弹窗 -->
    <el-dialog
      title="改派"
      :visible.sync="changeQcDialog"
      @close="changeQcDialog = false"
    >
      <section class="qcNameMain">
        <div class="d-f align-c m-b-10">
          <label class="w-90">任务截止时间</label>
          <el-date-picker
            v-model="limitTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            valueFormat="timestamp"
            :pickerOptions="this.pickerOptions"
            placeholder="选择任务截止时间"
          ></el-date-picker>
        </div>
        <div class="d-f align-c m-b-10">
          <label class="w-90">质控单价</label>
          <el-input-number
            class="m-r-5"
            v-model="qcPrice"
            :controls="false"
            :precision="2"
            placeholder="请输金额"
          />
          元（千字单价）
        </div>
        <div class="d-f align-c m-b-10">
          <label class="w-90">额外费用</label>
          <el-input-number
            class="m-r-5"
            v-model="extAmount"
            :controls="false"
            :precision="2"
            placeholder="请输金额"
          />
          元
        </div>
        <div class="d-f justify-s align-c m-b-10">
          <label class="w-90">质控人</label>
          <div>
            <el-button type="primary" plain @click.stop="showZktr()">
              选择质控人
            </el-button>
          </div>
          <span class="c-primary m-l-10">{{ reQcName }}</span>
        </div>
      </section>
      <div class="l-h-24 m-t-10 f-s-12 f-w-600">
        <span class="c-red">说明：</span>
        改派后任务将会自动进入新的质控人进行中的任务列表，无需领取操作。原处理人将无法访问此任务，也无此项目收入！请确定与原质控人协调一致后谨慎操作！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reAssign">确认</el-button>
        <el-button type="primary" @click="changeQcDialog = false" plain>
          取消
        </el-button>
      </span>
    </el-dialog>

    <!-- 操作日志 -->
    <el-dialog
      width="75%"
      title="操作日志"
      :visible.sync="reAssignLogDialog"
      @close="reAssignLogDialog = false"
    >
      <el-table :data="logList" border :size="small">
        <el-table-column
          prop="modifiedName"
          label="操作项"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="oldValue"
          label="操作前"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="newValue"
          label="操作后"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="操作原因"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="operator"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="t-c" v-if="page.total > 10">
        <el-pagination
          class="p-t-10"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-size="page.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-dialog>

    <!-- 选择邀请人弹窗 -->
    <el-dialog
      title="选择邀请人"
      :visible.sync="dialogZktr"
      @close="handleClose"
      width="80%"
    >
      <avue-crud
        :option="qcNameOption"
        :data="childQcData"
        :page.sync="page1"
        :search.sync="search"
        @size-change="sizeChange"
        @current-change="currentChange"
        @search-change="searchChange"
        ref="crud"
      >
        <template slot-scope="{ row, index }" slot="search">
          <section class="d-f">
            <span class="p-t-5">质控人：</span>
            <div class="w-70 m-r-10">
              <el-input
                v-model="search.nickName"
                placeholder="请输入质控人"
                clearable
              ></el-input>
            </div>
            <span class="p-t-5">是否在圈：</span>
            <div class="w-70 m-r-10">
              <el-select
                v-model="search.isCircle"
                clearable
                placeholder="请选择"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </div>
            <span class="p-t-5">资源类型：</span>
            <div class="w-90">
              <el-select
                v-model="search.userType"
                clearable
                placeholder="请选择"
              >
                <el-option label="兼职" value="PT"></el-option>
                <el-option label="全职" value="FT"></el-option>
                <el-option label="团队" value="TT"></el-option>
                <el-option label="公司" value="CO"></el-option>
              </el-select>
            </div>
            <span class="p-t-5 m-l-10">是否新人：</span>
            <div class="w-85">
              <el-select v-model="search.isNew" clearable placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </div>
          </section>
          <div class="el-form-item el-form-item--small l-h-32 m-l-10">
            <el-checkbox v-model="isProceed" @change="changeProceed">
              未被占用
              <span class="f-s-12">（无进行中任务 ）</span>
            </el-checkbox>
          </div>
        </template>
        <template slot="circleName" slot-scope="scope">
          {{ scope.row.circleName ?? '--' }}
        </template>
        <template slot="newPerson" slot-scope="scope">
          <span v-if="scope.row.newPerson === 2">是</span>
          <span v-if="scope.row.newPerson === 1">否</span>
        </template>
        <template slot="releaseTime" slot-scope="scope">
          <span>{{ scope.row.releaseTime > 0 ? '是' : '否' }}</span>
          <span v-if="scope.row.releaseTime > 0">
            （预计
            <span class="c-red">{{ formatDate(scope.row?.releaseTime) }}</span>
            释放）
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="menu">
          <!-- 后期如果人多了还会加上限制条件，所以代码先注释掉 -->
          <!-- <el-button :disabled="currentRow==0&&(row.taskNum<10 && row.userType=='兼职')" type="primary" size="mini" @click.stop="addTr(row,index)">添加</el-button> -->
          <el-button type="primary" size="mini" @click.stop="addTr(row, index)">
            添加
          </el-button>
        </template>
      </avue-crud>
    </el-dialog>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue';
import {
  configQcTaskAmountByPm,
  updateQcTask,
  listQC,
  pageSelectQc,
  qcConfigInfo,
  seleteById,
  updateQcTaskWordByPm,
  getDotOrderWordTj,
  saveQcTaskFlag,
  deleteQcTaskFlag,
  getAmountByTaskId,
  getUndealtWordNum,
  getTotalAmount,
  getDiscount,
  dispatchQc,
  getFlowInfo,
  reAssignQcTask,
  qcTaskLogList,
} from '@/api/dot/qc';
import { recommend } from '@/api/dot/order';
import { statistics, getByType } from '@/api/dot/flow';
import { formatDate } from '@/util/date';
import { mapGetters } from 'vuex';
import { qcNameOption } from '@/const/crud/dot/qc';

const ORDER_STATUS = {
  toBeConfig: 1,
  toBeRecived: 2,
  underWay: 3,
  finished: 4,
};

export default {
  props: ['configInfo', 'slan', 'tlan', 'staParams'],
  data() {
    return {
      ORDER_STATUS,
      taskListOption: [], // 分配的任务列表
      currentRow: null, // 当前操作任务行
      qcNameList: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
        selectableRange: '',
      },
      configDisabled: false,
      childConfigInfo: JSON.parse(JSON.stringify(this.configInfo)),
      recommendPrice: {},
      qcData: [],
      qcNameOption: qcNameOption,
      childQcData: [],
      search: {
        userType: '',
        isCircle: null,
        isNew: '',
        isProceed: null,
      },
      isProceed: false,
      page1: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      newQcList: [],
      dialogZktr: false,
      surplusWord: this.configInfo.wordsCount, //剩余未分配字数
      mtInfo: {},
      pageFlag: null, //页面唯一标识
      rowFlag: null, //单条编辑唯一标识
      btnActFlag: false,
      totalAmount: 0,
      mtoutDisCount: 0, //机翻直出折扣
      exampleDisCount: 0, //例句直出折扣
      valid: {
        priceValid: true,
        wordNumValid: true,
      },
      skipStepFlag: false,
      showFirstStepBtn: true,
      showSecondStepBtn: true,
      changeQcDialog: false,
      qcNameList: [],
      qcNameId: null,
      extAmount: 0,
      qcPrice: 0,
      limitTime: null,
      reAssignLogDialog: false,
      reQcName: null,
      logList: [],
      page: {
        //操作日志分页
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      logTaskId: null,
      addBtnActFlag: false,
      batchPrice: null,
      batchAutoRange: null,
    };
  },

  computed: {
    ...mapGetters(['permissions', 'userInfo', 'roles']),
  },
  watch: {
    taskListOption() {
      this.createFlag();
    },
    'childConfigInfo.limitTime': {
      handler(newVal, oldVal) {
        this.setSelectRange(newVal);
      },
      deep: true,
    },
    limitTime: {
      handler(newVal, oldVal) {
        this.setSelectRange(newVal);
      },
      deep: true,
    },
  },

  created() {
    this.getDiscountData();
    this.pageFlag = new Date().getTime();
    this.getRecommend();
    if (
      this.childConfigInfo.status !== 1 ||
      this.childConfigInfo.distributedStatus == 1
    ) {
      this.getConfigList();
      this.getCurrentTotalAmount();
    } else {
      this.addQcTask();
    }
    if (this.configInfo.isMtOut) {
      this.getMtInfo();
    }
  },
  mounted() {
    console.log(123, this.configInfo);
    this.createFlag();
    if (this.childConfigInfo.status == 3) {
      //进行中
      this.wordNumNotice();
    }
  },
  methods: {
    blurBatchPrice() {
      this.taskListOption.forEach((item) => {
        if (!item.price) {
          item.price = this.batchPrice;
        }
      });
    },
    setBatchRange() {
      this.taskListOption.forEach((item) => {
        if (item.isMatch === 2 && !item.autoRange) {
          item.autoRange = this.batchAutoRange;
        }
      });
    },
    isMainQC(task) {
      return task.taskType == 1;
    },
    showHandInvite(task) {
      const isWaitTooLong =
        new Date().getTime() - task.sendTime > 20 * 60 * 1000;
      const isConfiged = this.childConfigInfo.status > ORDER_STATUS.toBeConfig;
      return (
        this.isMainQC(task) ||
        (isConfiged && isWaitTooLong) ||
        task.isMatch === 1
      );
    },
    setSelectRange(newVal) {
      const now = new Date().getTime();
      if (this.formatDay(newVal) === this.formatDay(now)) {
        const currentTime = this.formatDateTime(now);
        this.pickerOptions.selectableRange = `${currentTime} - 23:59:59`;
      } else {
        this.pickerOptions.selectableRange = '00:00:00 - 23:59:59';
      }
    },
    formatDay(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd');
    },
    formatDateTime(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'hh:mm:ss');
    },
    createFlag() {
      const flag = this.taskListOption.some((item) => {
        return item.status == 0;
      });
      if (flag && this.childConfigInfo.status !== 1) {
        this.addBtnActFlag = true;
      } else {
        this.addBtnActFlag = false;
      }
    },
    // 进行中状态，有剩余待分配字数则给提示
    wordNumNotice() {
      getUndealtWordNum({
        orderId: this.$route.query.orderId,
        flag: this.configInfo.status == 1 ? this.pageFlag : '',
      }).then((res) => {
        this.surplusWord = res.data?.data?.wordCountUndealed;
        if (this.surplusWord > 0) {
          this.$alert(
            '当前仍然有剩余待分配字数，请完成质控任务分配，否则剩余的字数将无人质控！',
            '质控配置提醒',
            {
              confirmButtonText: '知道了',
            },
          );
        }
      });
    },
    // 点击跳过第一步
    skipFirstStep() {
      this.skipStepFlag = true;
      this.showFirstStepBtn = false;
      this.showSecondStepBtn = false;
    },
    // 点击系统派单按钮
    sysDispatch() {
      if (!this.childConfigInfo.limitTime) {
        this.$message.error('请选择任务截止时间');
        return;
      }
      dispatchQc({
        orderId: this.$route.query.orderId,
        limitTime: this.childConfigInfo.limitTime,
      }).then((res) => {
        getFlowInfo(this.$route.params.id).then((resp) => {
          this.showFirstStepBtn = false;
          this.childConfigInfo.limitTime = resp?.data?.data?.limitTime;
          this.childConfigInfo.distributedStatus =
            resp?.data?.data?.distributedStatus;
          this.childConfigInfo.status = resp?.data?.data?.status;
        });
      });
    },
    // 日志
    openLogList(qcTaskId) {
      this.logTaskId = qcTaskId;
      this.reAssignLogDialog = true;
      qcTaskLogList({
        qcTaskId: qcTaskId,
      }).then((res) => {
        this.logList = res?.data?.data;
      });
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.openLogList(this.logTaskId);
    },
    // 获取质控人
    getQcNameList() {
      this.changeQcDialog = true;
      listQC({
        slan: this.slan,
        tlan: this.tlan,
      }).then((res) => {
        this.qcNameList = res?.data?.data;
      });
    },
    openReAssign(row) {
      this.reAssignRow = row;
      this.limitTime = row.limitTime;
      this.qcPrice = row.price;
      this.extAmount = row.extraAmount;
      this.qcNameId = row.qcId;
      this.reQcName = row.receiver;
      this.getQcNameList();
      this.changeQcDialog = true;
    },

    // 改派
    reAssign() {
      if (!this.qcNameId || !this.limitTime || this.qcPrice == null) {
        this.$message.error('请填写改派信息');
        return;
      }
      reAssignQcTask({
        qcTaskId: this.reAssignRow.id,
        qcId: this.qcNameId,
        limitTime: this.limitTime,
        extraAmount: this.extAmount,
        price: this.qcPrice,
        operator: this.userInfo?.realname,
        orderId: this.reAssignRow.orderId,
      }).then((res) => {
        this.$message.success('改派成功');
        this.changeQcDialog = false;
        this.getConfigList();
      });
    },
    // 获取直出和例句折扣
    getDiscountData() {
      getDiscount({}).then((res) => {
        this.exampleDisCount = res.data?.data?.exampleDisCount;
        this.mtoutDisCount = res.data?.data?.mtoutDisCount;
      });
    },

    // 获取剩余待分配字数
    getSurplusWord(index) {
      const wordArr = this.taskListOption.map((item) => {
        return item.wordNum ? Number(item.wordNum) : 0;
      });
      const wordTotal = wordArr.reduce((a, b) => {
        return a + b;
      }, 0);
      if (this.configInfo.wordsCount - wordTotal >= 0) {
        return (this.surplusWord = this.configInfo.wordsCount - wordTotal);
      } else {
        this.taskListOption[index].wordNum = undefined;
        this.$message.error('超出剩余待分配字数，分配失败，请重新分配字数');
        this.getSurplusWord();
      }
    },

    // 获取质控总价
    getCurrentTotalAmount() {
      getTotalAmount({ orderId: this.$route.query.orderId }).then((res) => {
        this.totalAmount = res.data?.data?.amount;
      });
    },

    formatDate(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    // 新增质控任务
    addQcTask() {
      this.createFlag();
      if (this.btnActFlag || this.addBtnActFlag) {
        return;
      }
      getByType({
        orderId: this.$route.query.orderId,
        type: 6,
      }).then((res) => {
        let status = res.data?.data?.status;
        if (status < 1 || status > 3) {
          this.$message.error('任务状态已改变');
          this.$router.replace({
            path: '/refresh',
          });
        } else {
          saveQcTaskFlag({
            orderId: this.$route.query.orderId,
            flag: this.configInfo.status == 1 ? this.pageFlag : '',
          }).then((res) => {
            this.taskListOption.push({
              id: res.data?.data?.id,
              taskType: res.data?.data?.taskType,
              isEdit: this.configInfo.status == 1 ? true : false,
              price: null,
              wordNum: null,
              sentNum: 0,
              extraAmount: 0,
              amount: 0,
              isMatch: res.data?.data?.taskType == 1 ? null : 2,
              autoRange: null,
              userWebVos: [],
              status: 0,
              normalWordNum: 0,
              mtoutWordNum: 0,
              exampleWordNum: 0,
              mtoutSentNum: 0,
              exampleSentNum: 0,
              mtoutAmount: 0,
              exampleAmount: 0,
              limitTime: res.data?.data?.limitTime,
            });
          });
        }
      });
    },

    // 删除质控任务
    deleteTask(row) {
      if (row.status == 1) {
        let msg = `<div>您进行了删除子质控任务操作。删除后，此质控任务字数将会释放到<span class="c-red">“剩余待分配字数”</span>中，<span class="c-red">需要重新完成质控字数的分配。直到剩余待分配字数为0；</span></div><div class="m-t-5">请确认是否删除此条子质控任务？</div>`;
        this.$confirm(msg, '子质控任务删除提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
        })
          .then(() => {
            this.deleteTaskFuc(row);
          })
          .catch(() => {});
      } else {
        this.deleteTaskFuc(row);
        this.createFlag();
      }
    },

    // 删除任务方法
    deleteTaskFuc(row) {
      deleteQcTaskFlag({
        orderId: this.$route.query.orderId,
        flag: this.configInfo.status == 1 ? this.pageFlag : '',
        qcTaskId: row.id,
      }).then((res) => {
        if (row.status == 0) {
          this.taskListOption.splice(row.index, 1);
        } else if (row.status == 1) {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getConfigList();
        }
        this.rowFlag = new Date().getTime();
        this.getCurrentTotalAmount();
        this.getSurplusWord();
      });
    },

    // 获取机翻直出信息
    getMtInfo() {
      getDotOrderWordTj({
        orderId: this.$route.query.orderId,
      }).then((res) => {
        this.mtInfo = res?.data?.data;
      });
    },

    // 限制数字输入框
    handlerEditNum(e) {
      e.target.value =
        !e.target.value || isNaN(e.target.value)
          ? null
          : parseInt(e.target.value);
    },

    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    // 切换选择质控人方式
    changeMatchType(e, index) {
      this.taskListOption[index].isMatch = e;
      this.taskListOption[index].userWebVos = [];
      this.taskListOption[index].qcNameList = '';
      this.checkConfigInfo();
    },

    // 清空当前行
    resetRow(index) {
      this.taskListOption[index].price = null;
      this.taskListOption[index].isMatch = null;
      this.taskListOption[index].userWebVos = [];
      this.taskListOption[index].extraAmount = 0;
      this.taskListOption[index].wordNum = 0;
      this.taskListOption[index].sentNum = 0;
      this.taskListOption[index].amount = 0;
      this.checkConfigInfo();
    },

    // 获取建议价格
    getRecommend() {
      recommend(this.$route.query.orderId, 3).then((res) => {
        this.recommendPrice = res.data.data;
      });
    },

    // 选择质控人弹窗
    showZktr(index) {
      this.currentRow = index;
      this.getQcList(this.page1);
      this.dialogZktr = true;
    },

    // 关闭质控人弹窗
    handleClose() {
      this.dialogZktr = false;
      this.search.nickName = '';
      this.search.userType = '';
      this.search.isNew = '';
      this.isProceed = false;
      this.search.isCircle = false;
      this.$refs.crud.searchReset();
    },

    // 获取质控人列表
    getQcList(page1, params) {
      pageSelectQc(
        Object.assign(
          {
            current: page1.currentPage,
            size: page1.pageSize,
          },
          params,
          {
            slan: this.slan,
            tlan: this.tlan,
          },
        ),
      ).then((res) => {
        this.qcData = res.data?.data?.records;
        this.childQcData = this.qcData;
        this.page1.total = res.data?.data?.total;
      });
    },

    sizeChange(pageSize) {
      this.page1.pageSize = pageSize;
      this.page1.currentPage = 1;
      this.getQcList(this.page1, this.search);
    },
    currentChange(currentPage) {
      this.page1.currentPage = currentPage;
      this.getQcList(this.page1, this.search);
    },

    // 质控人弹窗-搜索
    searchChange(form, done) {
      done();
      this.search = form;
      this.page1.currentPage = 1; //避免翻页了再搜索为空的情况，明明应该有数据
      this.search.isProceed = Number(!this.isProceed);
      this.getQcList(this.page1, form, this.search);
    },

    // 添加质控人
    addTr(row, index) {
      if (this.changeQcDialog) {
        this.qcNameId = row.staffId;
        this.reQcName = row.realname;
        this.dialogZktr = false;
      } else {
        if (this.taskListOption[this.currentRow].userWebVos == null) {
          this.taskListOption[this.currentRow].userWebVos = [];
        }
        if (this.childConfigInfo.qcList == null) {
          this.childConfigInfo.qcList = [];
        }
        let temp = [];
        temp = temp
          .concat(this.taskListOption[this.currentRow].userWebVos)
          .concat(this.childConfigInfo.qcList);
        if (!temp.find((item) => item.staffId === row.staffId)) {
          this.taskListOption[this.currentRow].userWebVos.push(row);
          this.$message.success(row.realname + '，添加成功');
        } else {
          this.$message.error(row.realname + '，已添加该质控人');
        }
        let qcIds = this.taskListOption[this.currentRow].userWebVos.map(
          (item) => {
            return item.staffId;
          },
        );
        this.taskListOption[this.currentRow].qcIds = qcIds;
        let qcNameList = this.taskListOption[this.currentRow].userWebVos.map(
          (item) => {
            return item.realname;
          },
        );
        this.taskListOption[this.currentRow].qcNameList = qcNameList.join('/');
        this.checkConfigInfo();
      }
    },

    // 清空质控人
    delAllZkr(index) {
      this.taskListOption[index].userWebVos = [];
      this.qcNameList = '';
      this.checkConfigInfo();
    },

    // 确认分配质控
    confirmConfig() {
      let peEndTime = this.childConfigInfo.peEndTime
        ? parseInt(this.childConfigInfo.peEndTime)
        : 0;
      if (this.childConfigInfo.peEndTime) {
        if (
          (this.childConfigInfo.status === 1 ||
            this.childConfigInfo.status === 2) &&
          this.childConfigInfo.limitTime < peEndTime
        ) {
          this.$message.error('不可选择小于PE结束时间');
          return;
        }
      }
      configQcTaskAmountByPm({
        orderId: this.$route.query.orderId,
        flag: this.pageFlag,
        limitTime: this.childConfigInfo.limitTime,
        list: this.taskListOption,
      }).then((res) => {
        /* this.childConfigInfo.status = 2;
        this.surplusWord = 0;
        this.getConfigList();
        this.getCurrentTotalAmount(); */
        this.$router.replace({
          path: '/refresh',
        });
      });
    },

    // 获取配置后的任务列表
    getConfigList() {
      qcConfigInfo({
        orderId: this.$route.query.orderId,
        qcOrPm: '',
      }).then((res) => {
        this.taskListOption = res.data.data.map((item) => {
          item.wordNum = item.wordNum == 0 ? undefined : item.wordNum;
          let qcNameList = item.userWebVos.map((item) => {
            return item.realname;
          });
          return Object.assign(item, {
            isEdit: this.childConfigInfo.status > 1 ? false : true,
            qcNameList: qcNameList.join('/'),
          });
        });
        this.btnActFlag = false;
        this.getSurplusWord();
        this.checkConfigInfo();
      });
    },

    // 单条编辑
    updateRow(index) {
      seleteById({
        qcTaskId: this.taskListOption[index]?.id,
      }).then((res) => {
        if (res.data.data.status > 1 || res.data.data.status == -1) {
          this.$message.error('此质控任务状态已改变，请刷新页面');
          this.$router.replace({
            path: '/refresh',
          });
          return;
        }
        this.rowFlag = new Date().getTime();
        this.taskListOption[index].isEdit = true;
        this.btnActFlag = true;
      });
    },

    // 单条修改配置
    updateConfig(index) {
      if (!this.valid.priceValid || !this.valid.wordNumValid) {
        return;
      }
      if (
        this.taskListOption[index].price == 0 ||
        this.taskListOption[index].wordNum == 0
      ) {
        this.$message.error('价格和字数不能为0');
        return;
      }
      if (
        this.taskListOption[index].price == null ||
        this.taskListOption[index].wordNum == '' ||
        this.taskListOption[index].wordNum == null ||
        this.taskListOption[index].limitTime == null ||
        !this.taskListOption[index].isMatch ||
        (this.taskListOption[index].isMath == 2 &&
          !this.taskListOption[index].autoRange) ||
        (this.taskListOption[index].isMatch == 1 &&
          !this.taskListOption[index].userWebVos.length)
      ) {
        this.$message.error('请先完成任务配置');
        return;
      }
      if (
        this.childConfigInfo.status === 1 &&
        this.taskListOption[index].limitTime < Date.now()
      ) {
        this.$message.error('不可选择过去时间');
        return;
      }
      let peEndTime = this.childConfigInfo.peEndTime
        ? parseInt(this.childConfigInfo.peEndTime)
        : 0;
      if (
        (this.childConfigInfo.status === 1 ||
          this.childConfigInfo.status === 2) &&
        this.taskListOption[index].limitTime < peEndTime
      ) {
        this.$message.error('不可选择小于PE结束时间');
        return;
      }
      if (this.taskListOption[index].amount < 0) {
        this.$message.error('总金额不能小于0');
        return;
      }
      setTimeout(() => {
        updateQcTask({
          qcTaskId: this.taskListOption[index].id,
          price: this.taskListOption[index].price,
          extraAmount: this.taskListOption[index].extraAmount,
          limitTime: this.taskListOption[index].limitTime,
          qcIds: this.taskListOption[index].qcIds,
          isMatch: this.taskListOption[index].isMatch,
          autoRange:
            this.taskListOption[index].isMatch == 2
              ? this.taskListOption[index].autoRange
              : null,
          amount: this.taskListOption[index].amount,
          wordNum: this.taskListOption[index].wordNum,
          flag: this.rowFlag,
          operator: this.userInfo?.realname,
        })
          .then((res) => {
            this.wordNumNotice();
            this.getConfigList();
            this.getCurrentTotalAmount();
          })
          .catch(() => {
            this.$router.replace({
              path: '/refresh',
            });
          });
      }, 300);
    },

    // 取消
    cancelConfig() {
      this.getConfigList();
      this.getSurplusWord();
    },

    // 价格失焦事件
    blurPrice(index, price) {
      if (price == 0 || price == null || price == undefined) {
        this.taskListOption[index].price = undefined;
        this.valid.priceValid = false;
        this.$message.error('价格不能为0或空');
      } else {
        this.taskListOption[index].price = price;
        this.valid.priceValid = true;
      }
      this.checkConfigInfo();
      this.getTotalAmount(index);
    },

    // 计算总价
    getTotalAmount(index) {
      this.checkConfigInfo();
      getAmountByTaskId({
        price: this.taskListOption[index].price || 0,
        wordNum: this.taskListOption[index].wordNum || 0,
        mtoutWordNum: this.taskListOption[index].mtoutWordNum,
        exampleWordNum: this.taskListOption[index].exampleWordNum,
        extraAmount: this.taskListOption[index].extraAmount || 0,
      }).then((res) => {
        let data = res.data?.data;
        this.taskListOption[index].amount = res.data?.data?.amount;
        this.taskListOption[index].exampleWordNum = data?.exampleWordNum;
        this.taskListOption[index].mtoutWordNum = data?.mtoutWordNum;
        this.taskListOption[index].mtoutAmount = data?.mtoutAmount;
        this.taskListOption[index].exampleAmount = data?.exampleAmount;
        this.taskListOption[index].normalWordNum = data?.normalWordNum;
        this.taskListOption[index].normalAmount = data?.normalAmount;
      });
      this.getCurrentTotalAmount();
    },

    // 校验分配字数
    checkWordNum(index, wordNum) {
      if (wordNum == 0 || wordNum == null || wordNum == 'undefined') {
        this.taskListOption[index].wordNum = undefined;
        this.$message.error('质控任务字数不能为0或空');
        this.valid.wordNumValid = false;
      } else {
        this.taskListOption[index].wordNum = wordNum;
        this.valid.wordNumValid = true;
      }
      this.checkConfigInfo();
      this.getTotalAmount(index);
      this.getSurplusWord(index);
      // this.updateWordNum(index);
      this.getCurrentTotalAmount();
    },

    // 更新字数接口
    updateWordNum(index, type) {
      updateQcTaskWordByPm({
        flag: this.childConfigInfo.status == 1 ? this.pageFlag : this.rowFlag,
        orderId: this.$route.query.orderId,
        qcTaskId: this.taskListOption[index].id,
        extraAmount: this.taskListOption[index].extraAmount,
        price:
          this.taskListOption[index].price == null
            ? 0
            : this.taskListOption[index].price,
        word:
          this.taskListOption[index].wordNum == null
            ? 0
            : this.taskListOption[index].wordNum,
      }).then((res) => {
        const data = res.data?.data;
        if (data?.data == -5) {
          this.$message.error(res.data?.msg);
        }
        this.taskListOption[index].wordNum =
          data?.wordNum == 0 ? undefined : data?.wordNum;
        this.taskListOption[index].sentNum = data?.sentNum;
        this.taskListOption[index].amount = data?.amount;
        this.taskListOption[index].exampleWordNum = data?.exampleWordNum;
        this.taskListOption[index].mtoutWordNum = data?.mtoutWordNum;
        this.taskListOption[index].mtoutAmount = data?.mtoutAmount;
        this.taskListOption[index].exampleAmount = data?.exampleAmount;
        this.taskListOption[index].normalWordNum = data?.normalWordNum;
        this.taskListOption[index].normalAmount = data?.normalAmount;
        this.surplusWord = data?.wordCountUndealed;
      });
    },

    // 判断必填项
    checkConfigInfo() {
      for (let i = 0; i < this.taskListOption.length; i++) {
        if (
          this.taskListOption[i].wordNum == '' ||
          this.taskListOption[i].wordNum == null ||
          this.taskListOption[i].price === '' ||
          this.taskListOption[i].price === null ||
          this.taskListOption[i].price == 0 ||
          this.taskListOption[i].price == undefined ||
          this.taskListOption[i].isMatch == '' ||
          this.taskListOption[i].isMatch == null ||
          (this.taskListOption[i].isMatch == 1 &&
            !this.taskListOption[i].userWebVos.length) ||
          (this.taskListOption[i].isMatch == 2 &&
            !this.taskListOption[i].autoRange)
        ) {
          this.configDisabled = true;
          return;
        } else {
          this.configDisabled = false;
        }
      }
    },

    handleTime(val) {
      this.$forceUpdate(); //需要使用强制更新
      this.childConfigInfo.limitTime = val; //赋值
    },
  },
};
</script>

<style lang="scss" scoped>
.qcList {
  text-overflow: ellipsis;
  background: #b3d8ff;
  color: #ffffff;
  border-radius: 2px;
  max-width: 70px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
}
.border-t {
  border-top: 1px solid #ebeef5;
  height: 34px;
  line-height: 34px;
  margin-top: 8px;
  padding-top: 4px;
}
.qcNameList {
  background: none;
  color: #666;
}
.input-note {
  margin: 0;
}
ul.ul-zkr {
  padding: 0;
  > li {
    width: auto;
    height: 30px;
    display: inline-block;
    list-style: none;
    line-height: 30px;
    background: #b3d8ff;
    color: #ffffff;
    text-align: center;
    margin-right: 5px;
    border-radius: 3px;
    > span {
      padding: 0 5px;
    }
    > .el-icon-close {
      margin-right: 3px;
      cursor: pointer;
    }
  }
}
.el-dialog__wrapper {
  :deep(.avue-group--card:last-child) {
    margin-bottom: 0 !important;
  }
}
.el-row {
  min-height: 36px;
  &:last-child {
    margin-bottom: 0;
  }
}
.common-content {
  font-size: 14px;
}
.grid-content {
  font-size: 14px;
  font-weight: bold;
  font-family: 'Microsoft YaHei', sans-serif;
}
.bg-purple {
  font-size: 12px;
  color: lightgray;
}
.qcNameRadio {
  width: calc(100% - 90px);
}
.qcNameMain {
  max-height: 330px;
  overflow-y: scroll;
}
</style>
